import React, { useContext } from 'react';

import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

import { getComponentSetting } from 'components/modules/component-configuration/services/component-configuration';
import { PageContentContext } from 'components/modules/content/context';
import { getContentNodeSuggestions } from 'components/modules/content/services/content-suggestions';
import useRecipe from 'components/modules/foundation/hooks/use-recipe';

import { CURATED_HERO_COMPONENT } from '../../../hero/constants/component';
import {
  DYNAMIC_TILES_COMPONENT,
  DYNAMIC_TILES_TILE_COMPONENT,
  HERO_DEFAULT_COMPONENT_IDENTIFIERS,
} from '../../../hero/constants/custom-hero';
import { hasHeroOverrideForPage } from '../../../hero/services/custom-hero';
import { filterComponentConfigurations, getPageSettings } from '../../../pages/services/components';
import { PagePropType } from '../../../pages/types';
import { getPageContentNodeComponents } from '../../services/content-node';
import PageContentNode from '../PageContentNode';

import './PageContentNodes.scss';

const propTypes = {
  page: PagePropType.isRequired,
};

const defaultProps = {};

export default function PageContentNodes({ page }) {
  const { activeRecipeName } = useRecipe();
  const { settings, suggestions } = useContext(PageContentContext);

  const componentConfigurations = getPageContentNodeComponents(page);
  const isUsingCustomHero = hasHeroOverrideForPage(page);
  const pageSettings = getPageSettings(page, settings);
  const { pageType } = page;

  const filteredComponentConfigurations = filterComponentConfigurations(componentConfigurations, [
    {
      paramsFilter: _get(HERO_DEFAULT_COMPONENT_IDENTIFIERS, activeRecipeName, []).map(
        (componentIdentifier) => ({
          componentIdentifier,
        }),
      ),
      shouldApplyFilters: isUsingCustomHero,
      negate: true,
    },
    {
      paramsFilter: [{ fastId: DYNAMIC_TILES_COMPONENT }, { fastId: DYNAMIC_TILES_TILE_COMPONENT }],
      negate: true,
    },
    {
      paramsFilter: [{ fastId: CURATED_HERO_COMPONENT }],
      negate: true,
    },
  ]);

  return (
    <div className="page-content-nodes">
      {_isEmpty(filteredComponentConfigurations) && (
        <p className="no-content">No content can be configured for this page</p>
      )}
      {filteredComponentConfigurations.map((component) => {
        const setting = getComponentSetting(component, pageSettings, { pageType });
        const nodeSuggestions = getContentNodeSuggestions(suggestions, component);

        return (
          <PageContentNode
            key={component.id}
            component={component}
            setting={setting}
            suggestions={nodeSuggestions}
          />
        );
      })}
    </div>
  );
}

PageContentNodes.propTypes = propTypes;
PageContentNodes.defaultProps = defaultProps;
